import api from './api';

// Sessão 1 Frente A — endpoints §6.5 do PLANO

export interface TrustedProxy {
  id: number;
  cidr: string;
  label: string;
  enabled: boolean;
  inserted_by_user_id?: number;
  notes?: string;
  created_at: string;
}

export interface CreateTrustedProxyInput {
  cidr: string;
  label: string;
  notes?: string;
}

export async function listTrustedProxies(): Promise<{ data: TrustedProxy[] }> {
  const resp = await api.get<{ data: TrustedProxy[] }>('/admin/trusted-proxies');
  return resp.data;
}

export async function createTrustedProxy(input: CreateTrustedProxyInput): Promise<TrustedProxy> {
  const resp = await api.post<TrustedProxy>('/admin/trusted-proxies', input);
  return resp.data;
}

export async function deleteTrustedProxy(id: number): Promise<void> {
  await api.delete(`/admin/trusted-proxies/${id}`);
}
